(function () {
  const MOBILE_MQ = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function activate(section, index) {
    const tabs = Array.from(section.querySelectorAll('[data-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-panel]'));
    if (!tabs.length) return;

    const nextIndex = Math.max(0, Math.min(index, tabs.length - 1));

    tabs.forEach(function (tab, i) {
      const active = i === nextIndex;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    panels.forEach(function (panel, i) {
      const active = i === nextIndex;
      panel.classList.toggle('is-active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    const activeTab = tabs[nextIndex];
    if (activeTab && isMobile()) {
      activeTab.scrollIntoView({
        inline: 'center',
        block: 'nearest',
        behavior: 'smooth',
      });
    }
  }

  function bind(section) {
    if (!section || section.getAttribute('data-bound') === 'true') return;

    const list = section.querySelector('[data-tab-list]');
    if (!list) return;

    section.setAttribute('data-bound', 'true');

    list.addEventListener('click', function (event) {
      const tab = event.target.closest('[data-tab]');
      if (!tab || !list.contains(tab)) return;

      const index = parseInt(tab.getAttribute('data-tab-index'), 10);
      if (!Number.isFinite(index)) return;
      activate(section, index);
    });

    list.addEventListener('keydown', function (event) {
      const tabs = Array.from(section.querySelectorAll('[data-tab]'));
      if (!tabs.length) return;

      const current = event.target.closest('[data-tab]');
      if (!current || !list.contains(current)) return;

      const currentIndex = tabs.indexOf(current);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      activate(section, nextIndex);
      tabs[nextIndex].focus();
    });
  }

  function initAll(context) {
    const root = context || document;

    if (root.classList && root.classList.contains('featured-interview')) {
      bind(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.featured-interview') : [];
    sections.forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const sectionEl = event.target.closest ? event.target.closest('.featured-interview') : null;
    if (!sectionEl) return;

    const tab = event.target.closest('[data-tab]');
    const panel = event.target.closest('[data-panel]');
    let index = 0;

    if (tab) {
      index = parseInt(tab.getAttribute('data-tab-index'), 10) || 0;
    } else if (panel) {
      index = parseInt(panel.getAttribute('data-panel-index'), 10) || 0;
    } else {
      return;
    }

    activate(sectionEl, index);
  });
})();
